import StudentsMentorItem from './students-mentor-item'

export default StudentsMentorItem
